import NextLink from 'next/link';

import {Icon, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import * as css from './ReferenceItem.css';

export const ReferenceItem: React.FC<{
  id: string;
  isCarouselItem: boolean;
  authors: React.ReactNode;
  title: React.ReactNode;
  url: string;
}> = ({id, isCarouselItem, authors, title, url}) => (
  <div id={id} className={css.reference({isCarouselItem})}>
    <Text variant="label" color="deepBurgundy">
      {authors}
    </Text>
    <div className={css.referenceContent}>
      <Text color="doveGray" className={sprinkles({flex: 'flex', grow: 1})}>
        {title}
      </Text>
      <NextLink href={url} passHref>
        <Text
          as="a"
          variant="buttonSmall"
          color="orange"
          className={sprinkles({
            flex: 'inline',
            dir: 'row',
            items: 'center',
            textDecoration: 'underline',
            gap: [4, 8, 8],
          })}>
          <span className={sprinkles({display: ['inline', 'none', 'none']})}>See Reference</span>
          <Icon name="ArrowUpRight" color="orange" size="small" />
        </Text>
      </NextLink>
    </div>
  </div>
);
